var render = function render(){var _vm=this,_c=_vm._self._c;return _c('foreignObject',{attrs:{"x":_vm.x,"y":_vm.y,"width":_vm.size,"height":_vm.size}},[_c('b-badge',{attrs:{"variant":_vm.variant}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }